module.exports = __webpack_public_path__ + "img/vertical_7_7_8019.d67bb7ee.png";